import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Field } from 'redux-form';
import { Row, Col, FormGroup, Label, Card, CardBody, CardTitle, CardText } from 'reactstrap';

import logo from '../../../assets/images/integrations/posthog.webp';

const PostHogFields = () => {
    const { t }                  = useTranslation();
    const { isMobile, isTablet } = useSelector(state => state.ui);

    return (
        <div className="PostHogFields">
            <Row>
                <Col>
                    <Card>
                        <CardBody>
                            <CardTitle className="small">
                                <img src={logo} className="img rounded" alt={t('settings.integrations.posthog.title')} />
                                { t('settings.integrations.posthog.title') }
                            </CardTitle>
                            <CardText tag="div">
                                <Row>
                                    <Col>
                                        <FormGroup row>
                                            <Label lg={2} className={ !isMobile && !isTablet ? "text-right" : ""}>
                                                {t("settings.integrations.posthog.personal_api_key")}
                                            </Label>
                                            <Col lg={10}>
                                                <Field
                                                    component="input"
                                                    className="form-control"
                                                    type="password"
                                                    name="integrations.posthog.personal_api_key"
                                                    id="posthog_personal_api_key"
                                                    autoComplete="off"
                                                />
                                                <small className="form-text text-muted">
                                                    {t("settings.integrations.posthog.personal_api_key_help")}
                                                </small>
                                            </Col>
                                        </FormGroup>
                                        <FormGroup row>
                                            <Label lg={2} className={ !isMobile && !isTablet ? "text-right" : ""}>
                                                {t("settings.integrations.posthog.project_api_key")}
                                            </Label>
                                            <Col lg={10}>
                                                <Field
                                                    component="input"
                                                    className="form-control"
                                                    type="text"
                                                    name="integrations.posthog.project_api_key"
                                                    id="posthog_project_api_key"
                                                    autoComplete="off"
                                                />
                                                <small className="form-text text-muted">
                                                    {t("settings.integrations.posthog.project_api_key_help")}
                                                </small>
                                            </Col>
                                        </FormGroup>
                                        <FormGroup row>
                                            <Label lg={2} className={ !isMobile && !isTablet ? "text-right" : ""}>
                                                {t("settings.integrations.posthog.project_id")}
                                            </Label>
                                            <Col lg={10}>
                                                <Field
                                                    component="input"
                                                    className="form-control"
                                                    type="text"
                                                    name="integrations.posthog.project_id"
                                                    id="posthog_project_id"
                                                    placeholder="249644"
                                                    autoComplete="off"
                                                />
                                                <small className="form-text text-muted">
                                                    {t("settings.integrations.posthog.project_id_help")}
                                                </small>
                                            </Col>
                                        </FormGroup>
                                        <FormGroup row>
                                            <Label lg={2} className={ !isMobile && !isTablet ? "text-right" : ""}>
                                                {t("settings.integrations.posthog.host")}
                                            </Label>
                                            <Col lg={10}>
                                                <Field
                                                    component="input"
                                                    className="form-control"
                                                    type="text"
                                                    name="integrations.posthog.host"
                                                    id="posthog_host"
                                                    placeholder="https://eu.i.posthog.com"
                                                    autoComplete="off"
                                                />
                                            </Col>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </CardText>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default PostHogFields;
